import { Component, ElementRef, ViewChild } from '@angular/core';
import { PCESTransactionPendingLists } from '../models/PCES-transaction-pending-lists.model';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { GridApi, IServerSideDatasource, IServerSideGetRowsParams,  ICellRendererParams, ColDef} from 'ag-grid-community';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
//import { PcesDetailsComponent } from '../pces-client-lists/pces-client-details/pces-details.component';
import { PCESModalComponent } from '../pces-client-lists/pces-lists-modal/pces-lists-modal.component';
import { PCESClientCreatorComponent } from '../pces-client-lists/pces-client-creator/pces-client-creator.component';

@Component({
  selector: 'app-pces-transaction-pending-lists',
  templateUrl: './pces-transaction-pending-lists.component.html',
  styleUrls: ['./pces-transaction-pending-lists.component.scss']
})
export class PcesTransactionPendingListsComponent {

  // Assign Client details component to be the detail cell rendered
  //public detailCellRenderer: any = PcesDetailsComponent;  

  rowData: PCESTransactionPendingLists[] = [];

  total_amount: string = '';  
  no_of_transactions: number = 0;  
  
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private zone: NgZone) { }

  search_client: FormGroup = this.fb.group({
    clientname: [''],
    contact_email: [''],
  })

  private apiUrl = '/api/pces_lists/pces_transaction_pending_lists.php';

  // variable to store universal filter 
  universalFilter = ''

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  // define headers for the main Client list grid
  columnDefs: ColDef[] = [
    { field: 'pces_transaction_uuid', headerName: 'UUID', hide: true},
    {
      headerName: 'Client Name',
      field: 'contact_organization',
      cellStyle: {'font-weight': 'bold'},          
      //cellRenderer: 'agGroupCellRenderer',    // Add Drop Down Detail
      width: 400
    },
    {
      headerName: 'Factoring For', field: 'factoring_for',
      width: 350
    },
    { headerName: 'Total Amount', field: 'total_amount', cellRenderer: currencyFormatting, width: 150 },      
    { headerName: 'Currency', field: 'account_currency', width: 150 },      
    { headerName: 'Bank Code', field: 'bank_code', width: 150 },      
    { headerName: 'Transit No.', field: 'transit_number', width: 150 },      
    { headerName: 'Account No.', field: 'account_number', width: 150 },      
    { headerName: 'ABA Routing No.', field: 'aba_routing_no', width: 150 },      
    { headerName: 'RBC Client Number', field: 'rbc_client_number', width: 300 },      
    { headerName: 'RBC Client Shortname', field: 'rbc_client_shortname', width: 200 },            
    { headerName: 'Financial Inst.', field: 'financial_institution', width: 150 },           
    { headerName: 'Cheque No.', field: 'cheque_no', width: 150 },                                 
    {
      headerName: 'Status',
      field: 'status',
      width: 200
    },  
    {
      headerName: 'Action', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deletePendingTransaction(params);
          });
        });
        return button;
      }, editable: false, width: 100,
    },                                   
  ]

  //Apply filter dynmically
  ngAfterViewInit() {

    // initialize Positions data and customer dropdown
    this.updateTotalAmount()

    console.log('ngAfterViewInit:')
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const clientname = params.get('clientname');
        const factoringfor = params.get('factoringfor');
        
        if (clientname) {
          this.applyClientName(clientname);
          console.log('clientname:',clientname)
        }
        else if (factoringfor) {
          this.applyFactoringFor(factoringfor);
          console.log('factoringfor:',factoringfor)
        }
        else {
          this.agGrid.api.setFilterModel({});
        }
      });
    }
  }

  updateTotalAmount(): void {
    const urlApi = this.apiUrl;
        
    const total_amount_url = `${urlApi}?command=TRANSACTION_TOTAL_AMOUNT`;
    this.http.get(total_amount_url).subscribe((response: any) => {
      if (response) {
        console.log('total_amount:', response)
        this.total_amount = new Intl.NumberFormat().format(response.total_amount/100);
        this.no_of_transactions = response.no_of_transactions;
      }
    })

  }

  //Apply filter for ClientName
  applyClientName(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        clientname: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  //Apply filter for Factoring For
  applyFactoringFor(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        factoringfor: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  search() {
    const clientname = this.search_client.get('clientname')?.value
    const factoringfor = this.search_client.get('factoringfor')?.value
    if (clientname) {
      this.router.navigate(['/pces_transaction_pending_lists'], { queryParams: { clientname: clientname } });
    }
    else if (factoringfor) {
      this.router.navigate(['/pces_transaction_pending_lists'], { queryParams: { factoringfor: factoringfor } });
    }
    else {
      console.log('Invalid search data.')
    }    
  }

  //Reset the filter by setting to empty object
  resetFilter() {
    this.router.navigate(['/pces_transaction_pending_lists']);
    this.search_client.get('clientname')?.setValue('');
    this.search_client.get('factoringfor')?.setValue('');
  }  

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setServerSideDatasource(this.getServerSideDatasource());
    this.gridApi = params.api; 
  }


  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getPcesList(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                console.log(response);
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getPcesList(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const urlApi = this.apiUrl;

    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      console.log('Filter model:', filterModel);
      console.log('Filter', filter)

      let operator = '';
      let value = '';

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }

      return {
        column,
        operator,
        value,
      };
    });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };

    console.log('an array of filter object: ', filters)
    const url = `${urlApi}?startRow=${startRow}&endRow=${endRow}&universalFilter=${this.universalFilter}`;

    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return {
          rowData: response.data,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );

  }  

  deletePendingTransaction(params: any) {
    const dialogConfig = new MatDialogConfig();
    const pces_transaction_uuid = params.data.pces_transaction_uuid;
    const clientname = params.data.contact_organization;

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Pending Transaction',
        modalMessage: {uuid: params.data.pces_transaction_uuid, client_name: params.data.contact_organization},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
  
  createTransactionCDNFile() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Create CDN Transaction File',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

    
  createTransactionUSFile() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Create US Transaction File',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
    
  createTransactionCND_USFile() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Create US/CDN Transaction File',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  DeleteAllTransaction() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete ALL Transaction',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  pcesClientLists() {
    this.router.navigate(['/pces_client_lists']);
  }

}
// function for custom cell renderer for shipment types (colored)
function currencyFormatting(params: ICellRendererParams) {

  let element = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    currencySign: "accounting",
  }).format(params.value/100);
  return element;
}